import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const countPremiumTypeSlice = createApi({
    reducerPath: "countPremiumType",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://pbp.policy-parser.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        countPremiumType: builder.query({
            query: (data) => ({ url: "/api/v1/policy/aggregate", params: data, method: "GET" }),
        }),
    }),
});

export const { useCountPremiumTypeQuery } = countPremiumTypeSlice;
